module.exports = __webpack_public_path__ + "img/visa.05d2d57a.svg";